import React, { useState } from "react";
import { RxHamburgerMenu } from "react-icons/rx";
import MobileSideNav from "./MobileSideNav";
import AppSwitcher from "../AppSwitch/AppSwitcher";

const MobileNav = () => {
  const [openSideDrawer, setOpenSideDrawer] = useState(false);
  return (
    <>
      <header className="h-14 border-b border-white/10 bg-[#372e5e] flex items-center justify-between px-4 rounded-b-2xl">
        <div className="flex items-center gap-3 min-w-0">
          <div className="flex items-center gap-2.5">
            <img
              src="/static/images/seekho-white.png"
              alt="Logo"
              className="h-7 w-[90px]"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <AppSwitcher compact />
          <button
            onClick={() => setOpenSideDrawer(!openSideDrawer)}
            className="p-2 rounded-xl hover:bg-white/10 transition-colors duration-200"
          >
            <RxHamburgerMenu className="w-6 h-6 text-white" />
          </button>
        </div>
      </header>

      {openSideDrawer && (
        <div className="lg:hidden">
          <MobileSideNav
            openSideDrawer={openSideDrawer}
            setOpenSideDrawer={setOpenSideDrawer}
          />
        </div>
      )}
    </>
  );
};

export default MobileNav;
